// @styles
require('./aggregatorTinkResumeNoEntities.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const { withRouter } = require('react-router-dom');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
import { OKButton } from 'commonsComponents/OKButton';

// @constants
const { ITEMS } = require('./constants');

// @utilities
import { recordLink, TINK_PG_PAGE_NAME, TINK_PG_ADD_MY_FIRST_BANK_BUTTON } from 'utilities/tagging';

class AggregatorTinkResumeNoEntities extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getItems = () =>
    ITEMS.map((item, index) => (
      <div className="aggregator-tink-resume-no-entities__iconsContainer" key={`product-${index}`}>
        <div className="aggregator-tink-resume-no-entities__iconsBox">
          <div>
            <div>
              <span id={item.icon}>
                <i
                  className={classNames(`description-and-icon__item__icon icon,
                    ${{
                      [item.icon]: item.icon,
                      'description-and-icon__item__icon--with-background': true,
                    }} aggregator-tink-resume-no-entities__icon ${item.icon}`)}
                />
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="aggregator-tink-resume-no-entities__iconTitle">{item.title()}</div>
          <div className="aggregator-tink-resume-no-entities__iconDescription">{item.text()}</div>
        </div>
      </div>
    ));

  handleOnClick = () => {
    recordLink(
      TINK_PG_PAGE_NAME,
      TINK_PG_ADD_MY_FIRST_BANK_BUTTON,
      TINK_PG_ADD_MY_FIRST_BANK_BUTTON
    );

    this.props.history.push('/myprofile/global/entities/add');
  };

  render = () => {
    return (
      <div id="pg-other-banks" className="aggregator-resume-section__content__no-entities">
        <div className="aggregator-resume-section__header row">
          <h3 className="aggregator-tink-resume-no-entities__moduleTitle col-xs-12">
            {formatText('aggregatorResume-title')}
          </h3>
        </div>
        <div className="aggregator-tink-resume-no-entities__moduleContainer">
          <h2 className="aggregator-tink-resume-no-entities__title">
            {formatText('aggregatorResume-textSectionTitle')}
          </h2>
          <p className="aggregator-tink-resume-no-entities__subtitle">
            <FormattedText value="aggregatorResume-textSectionText" />
          </p>
          <div className="aggregator-tink-resume-no-entities__productsContainer">
            {this.getItems()}
          </div>
          <div className="aggregator-tink-resume-no-entities__buttonsWrapper">
            <OKButton modifier="secondary" onClick={() => this.handleOnClick()}>
              {formatText('aggregatorResume-buttonAddMyFirstEntity')}
            </OKButton>
          </div>
        </div>
      </div>
    );
  };
}

AggregatorTinkResumeNoEntities.propTypes = {
  aggregationData: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default withRouter(AggregatorTinkResumeNoEntities);
